/* redux-query queries & helpers */

import * as _ from 'lodash';

import * as LK from '../config/apilookupkeys';
import ApiEndpoints from '../config/apiendpoints';
import { ApiQueryResponse } from './apiqueryresponse';
import { Formatters } from '../common/formatters';

export const RequestOptionsWithAuth = (accessToken: string) => {
    // Return redux-query request options with authorization header populated
    return {
        // credentials: 'include', // CORS
        headers: {
            'Accept': 'application/json',
            'Authorization': `Bearer ${accessToken}`,
        }
    };
};

export const BaseRequestWithAuth = (accessToken: string) => {
    // Returns base request config with authorization
    return {
        options: RequestOptionsWithAuth(accessToken),
        force: true,
    };
};

export const PropsAccessToken = (props: any): string => {
    // Returns access token from props
    return _.get(props, 'authsession.access_token', '');
};

export const UpdateToNext = (prev, next) => next;

export const MergeWithPre = (prev, next) => _.unionBy(prev, next, 'researchId');

export const Queries = {
    downloadKMLMutation: (accessToken: string, userData: any, optimistic: boolean = false) => {
        // const username = Formatters.getInt(userData, 'username');

        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: ApiEndpoints.downloadKMLUrl(),
            body: userData,
            transform: (data) => {
                return data;
                // const apiResponse = new ApiQueryResponse(data);

                // return {
                //     downloadKMLFile: apiResponse.getResponseObject()
                // };
            },
            // update: {
            // newUserDetail: UpdateToNext,
            // },
        });
    },
    getActiveOrdersRequest: (url: string, accessToken: string, filterCoordinator: string, filterManager: string, filterRegionId: any, filterStatusId: any) => {
        // OLD METHOD
        // Request api endpoint: search active jobs
        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: url,
            body: {
                coordinator: filterCoordinator,
                manager: filterManager,
                regionId: Formatters.int(filterRegionId),
                statusId: Formatters.int(filterStatusId),
            },
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);
                return {
                    searchActiveJobsRegions: apiResponse.getFieldAsArray('regions', true),
                    searchActiveJobsResults: apiResponse.getFieldAsArray('orders', true),
                    searchActiveJobsStatuses: apiResponse.getFieldAsArray('statuses', true),
                    searchActiveJobsUsers: apiResponse.getFieldAsArray('users', true),
                    searchActiveJobsUsersManagers: apiResponse.getFieldAsArray('usersManagers', true),
                    searchActiveJobsUsersCoordinators: apiResponse.getFieldAsArray('usersCoordinators', true),
                };
            },
            update: {
                searchActiveJobsRegions: UpdateToNext,
                searchActiveJobsResults: UpdateToNext,
                searchActiveJobsStatuses: UpdateToNext,
                searchActiveJobsUsers: UpdateToNext,
                searchActiveJobsUsersManagers: UpdateToNext,
                searchActiveJobsUsersCoordinators: UpdateToNext,
            },
        });
    },

    searchActiveJobsRequest: (url: string, accessToken: string, filterCoordinator: string, filterManager: string, filterRegionId: any, filterStatusId: any) => {
        // Request api endpoint: search active jobs
        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: url,
            body: {
                coordinator: filterCoordinator,
                manager: filterManager,
                regionId: Formatters.int(filterRegionId),
                statusId: Formatters.int(filterStatusId),
            },
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);
                return {
                    searchActiveJobsRegions: apiResponse.getFilterAsArray(LK.LookupKeys.Regions, true),
                    searchActiveJobsResults: apiResponse.getResultsArray(true),
                    searchActiveJobsStatuses: apiResponse.getFilterAsArray(LK.LookupKeys.Statuses, true),
                    searchActiveJobsUsers: apiResponse.getFilterAsArray(LK.LookupKeys.Users, true),
                    searchActiveJobsUsersManagers: apiResponse.getFilterAsArray(LK.LookupKeys.UsersManagers, true),
                    searchActiveJobsUsersCoordinators: apiResponse.getFilterAsArray(LK.LookupKeys.UsersCoordinators, true),
                };
            },
            update: {
                searchActiveJobsRegions: UpdateToNext,
                searchActiveJobsResults: UpdateToNext,
                searchActiveJobsStatuses: UpdateToNext,
                searchActiveJobsUsers: UpdateToNext,
                searchActiveJobsUsersManagers: UpdateToNext,
                searchActiveJobsUsersCoordinators: UpdateToNext,
            },
        });
    },

    searchPreparedBidsRequest: (url: string, accessToken: string, filterManager: string, filterRegionId: any, filterStatusId: any) => {
        // Request api endpoint: search prepared bids
        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: url,
            body: {
                manager: filterManager,
                regionId: Formatters.int(filterRegionId),
                statusId: Formatters.int(filterStatusId),
            },
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);
                return {
                    searchPreparedBidsRegions: apiResponse.getFilterAsArray(LK.LookupKeys.Regions, true),
                    searchPreparedBidsResults: apiResponse.getResultsArray(true),
                    searchPreparedBidsStatuses: apiResponse.getFilterAsArray(LK.LookupKeys.Statuses, true),
                    searchPreparedBidsUsers: apiResponse.getFilterAsArray(LK.LookupKeys.Users, true),
                };
            },
            update: {
                searchPreparedBidsRegions: UpdateToNext,
                searchPreparedBidsResults: UpdateToNext,
                searchPreparedBidsStatuses: UpdateToNext,
                searchPreparedBidsUsers: UpdateToNext,
            },
        });
    },

    searchSendBidsRequest: (url: string, accessToken: string, filterManager: string, filterRegionId: any, filterStatusId: any) => {
        // Request api endpoint: search prepared bids
        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: url,
            body: {
                manager: filterManager,
                regionId: Formatters.int(filterRegionId),
                statusId: Formatters.int(filterStatusId),
            },
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);
                console.log(apiResponse);
                return {
                    searchSendBidsRegions: apiResponse.getFilterAsArray(LK.LookupKeys.Regions, true),
                    searchSendBidsResults: apiResponse.getResultsArray(true),
                    searchSendBidsStatuses: apiResponse.getFilterAsArray(LK.LookupKeys.Statuses, true),
                    searchSendBidsUsers: apiResponse.getFilterAsArray(LK.LookupKeys.Users, true),
                };
            },
            update: {
                searchSendBidsRegions: UpdateToNext,
                searchSendBidsResults: UpdateToNext,
                searchSendBidsStatuses: UpdateToNext,
                searchSendBidsUsers: UpdateToNext,
            },
        });
    },

    searchAssociationExportOrdersFiltersRequest: (url: string, accessToken: string) => {
        // Request api endpoint: search association orders filters for export
        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: url,
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);
                return {
                    searchAssociationExportOrdersRegions: apiResponse.getFilterAsArray(LK.LookupKeys.Regions, true),
                    searchAssociationExportOrdersStatuses: apiResponse.getFilterAsArray(LK.LookupKeys.Statuses, true),
                };
            },
            update: {
                searchAssociationExportOrdersRegions: UpdateToNext,
                searchAssociationExportOrdersStatuses: UpdateToNext,
            },
        });
    },

    searchAssociationExportOrdersRequest: (url: string, accessToken: string, filterRegionId: any, filterStatusId: any, fromBidDate: any, toBidDate: any) => {
        // Request api endpoint: search association orders for export
        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: url,
            body: {
                fromBidDate: fromBidDate,
                toBidDate: toBidDate,
                regionId: Formatters.int(filterRegionId),
                statusId: Formatters.int(filterStatusId),
            },
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);
                return {
                    searchAssociationExportOrdersResults: apiResponse.getResultsArray(true),
                };
            },
            update: {
                searchAssociationExportOrdersResults: UpdateToNext,
            },
        });
    },

    searchAssociationsRequest: (url: string, accessToken: string, term: string, associationId: any, operator: string) => {
        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: url,
            body: {
                searchTerm: term,
                associationId: Formatters.int(associationId),
                operator: operator
            },
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);
                return {
                    searchAssociationsResults: apiResponse.getResultsArray(true),
                };
            },
            update: {
                searchAssociationsResults: UpdateToNext
            },
        });
    },

    searchClientDashboardRequest: (url: string, accessToken: string, term: string, operator: string) => {
        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: url,
            body: {
                searchTerm: term,
                operator: operator
            },
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);
                return {
                    searchClientDashboardResults: apiResponse.getResultsArray(true),
                    searchClientDashboardModelType: apiResponse.getFieldAsObject('modelType'),
                };
            },
            update: {
                searchClientDashboardResults: UpdateToNext,
                searchClientDashboardModelType: UpdateToNext,
            },
        });
    },

    searchClientsRequest: (url: string, accessToken: string, term: string, operator: string) => {
        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: url,
            body: {
                searchTerm: term,
                operator: operator
            },
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);
                return {
                    searchClientsResults: apiResponse.getResultsArray(true),
                };
            },
            update: {
                searchClientsResults: UpdateToNext
            },
        });
    },

    // searchClientContactsRequest: (url: string, accessToken: string, fromDate: any, coordinator: string, statusId: any, toDate: any, regionId: any, paid: any) => {
    searchClientContactsRequest: (url: string, accessToken: string, regionId: any, clientTypeId: any) => {
        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: url,
            body: {
                // coordinator: coordinator,
                // fromDate: fromDate,
                // paid: Formatters.int(paid),
                regionId: Formatters.int(regionId),
                clientTypeId: Formatters.int(clientTypeId),
                // statusId: Formatters.int(statusId),
                // toDate: toDate,
            },
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);
                return {
                    searchClientContactsRegions: apiResponse.getFilterAsArray(LK.LookupKeys.Regions, true),
                    searchClientContactsResults: apiResponse.getResultsArray(true),
                    searchClientContactsClientTypes: apiResponse.getFilterAsArray(LK.LookupKeys.ClientTypes, true),
                    // searchClientContactsStatuses: apiResponse.getFilterAsArray(LK.LookupKeys.Statuses, true),
                    // searchClientContactsUsers: apiResponse.getFilterAsArray(LK.LookupKeys.Users, true),
                };
            },
            update: {
                searchClientContactsRegions: UpdateToNext,
                searchClientContactsResults: UpdateToNext,
                searchClientContactsClientTypes: UpdateToNext,
                // searchClientContactsStatuses: UpdateToNext,
                // searchClientContactsUsers: UpdateToNext,
            },
        });
    },

    searchUsersRequest: (url: string, accessToken: string, term: string, filterMode: number, operator: string) => {
        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: url,
            body: {
                searchTerm: term,
                operator: operator,
                filterMode: Formatters.int(filterMode),
            },
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);
                return {
                    searchUsersResults: apiResponse.getResultsArray(true),
                };
            },
            update: {
                searchUsersResults: UpdateToNext
            },
        });
    },

    searchOrdersFiltersRequest: (url: string, accessToken: string) => {
        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: url,
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);
                return {
                    searchOrdersAssociations: apiResponse.getFilterAsArray(LK.LookupKeys.Associations, true),
                    searchOrdersClients: apiResponse.getFilterAsArray(LK.LookupKeys.Clients, true),
                    searchOrdersStatuses: apiResponse.getFilterAsArray(LK.LookupKeys.Statuses, true),
                };
            },
            update: {
                searchOrdersAssociations: UpdateToNext,
                searchOrdersClients: UpdateToNext,
                searchOrdersStatuses: UpdateToNext,
            },
        });
    },

    searchOrdersRequest: (url: string, accessToken: string, associationId: any, clientId: any, statusId: any, operator: string) => {
        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: url,
            body: {
                associationId: Formatters.int(associationId),
                clientId: Formatters.int(clientId),
                operator: operator,
                statusId: Formatters.int(statusId),
            },
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);
                return {
                    searchOrdersResults: apiResponse.getResultsArray(true),
                };
            },
            update: {
                searchOrdersResults: UpdateToNext,
            },
        });
    },

    searchCoordinatorJobsRequest: (url: string, accessToken: string, fromDate: any, coordinator: string, statusId: any, toDate: any, regionId: any, paid: any) => {
        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: url,
            body: {
                coordinator: coordinator,
                fromDate: fromDate,
                paid: Formatters.int(paid),
                regionId: Formatters.int(regionId),
                statusId: Formatters.int(statusId),
                toDate: toDate,
            },
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);
                return {
                    searchCoordinatorJobsRegions: apiResponse.getFilterAsArray(LK.LookupKeys.Regions, true),
                    searchCoordinatorJobsResults: apiResponse.getResultsArray(true),
                    searchCoordinatorJobsStatuses: apiResponse.getFilterAsArray(LK.LookupKeys.Statuses, true),
                    searchCoordinatorJobsUsers: apiResponse.getFilterAsArray(LK.LookupKeys.Users, true),
                };
            },
            update: {
                searchCoordinatorJobsRegions: UpdateToNext,
                searchCoordinatorJobsResults: UpdateToNext,
                searchCoordinatorJobsStatuses: UpdateToNext,
                searchCoordinatorJobsUsers: UpdateToNext,
            },
        });
    },

    searchResearchComponentsRequest: (url: string, accessToken: string, searchTerm: string, componentId: number, fromDate: any, toDate: any, operator: any) => {
        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: url,
            body: {
                searchTerm: searchTerm,
                componentId: componentId,
                fromDate: fromDate,
                toDate: toDate,
                operator: operator,
            },
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);
                return {
                    searchResearchComponentsResults: apiResponse.getResultsArray(true),
                };
            },
            update: {
                searchResearchComponentsResults: UpdateToNext,
            },
        });
    },

    searchResearchBidsRequest: (
        url: string,
        accessToken: string,
        unitsLow: any,
        unitsHigh: any,
        buildingsLow: any,
        buildingsHigh: any,
        pools: any,
        spas: any,
        streets: any,
        associationTypeId: any,
        statusId: any,
        clientId: any,
        contactKeyword: string,
        regionId: any,
        fromBidDate: any,
        toBidDate: any,
        fromCompletionDate: any,
        toCompletionDate: any,
        operator: string,
        statusIdsMulti: any = [-1],
        spasMulti: any = [-1],
        poolsMulti: any = [-1],
        streetsMulti: any = [''],
        associationTypeIdsMulti: any = [-1],
        clientIdsMulti: any = [-1],
        regionIdsMulti: any = [-1],
    ) => {
        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: url,
            body: {
                associationTypeId: Formatters.int(associationTypeId),
                buildingsHigh: Formatters.int(buildingsHigh),
                buildingsLow: Formatters.int(buildingsLow),
                clientId: Formatters.int(clientId),
                contactKeyword: contactKeyword,
                fromBidDate: fromBidDate,
                toBidDate: toBidDate,
                fromCompletionDate: fromCompletionDate,
                toCompletionDate: toCompletionDate,
                pools: Formatters.int(pools),
                regionId: Formatters.int(regionId),
                spas: Formatters.int(spas),
                statusId: Formatters.int(statusId),
                streets: streets,
                unitsHigh: Formatters.int(unitsHigh),
                unitsLow: Formatters.int(unitsLow),
                operator: operator,

                associationTypeIdsMulti: associationTypeIdsMulti,
                clientIdsMulti: clientIdsMulti,
                poolsMulti: poolsMulti,
                regionIdsMulti: regionIdsMulti,
                spasMulti: spasMulti,
                statusIdsMulti: statusIdsMulti,
                streetsMulti: streetsMulti,
            },
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);
                return {
                    researchBidsAssociationTypes: apiResponse.getFilterAsArray(LK.LookupKeys.AssociationTypes, true),
                    researchBidsClients: apiResponse.getFilterAsArray(LK.LookupKeys.Clients, true),
                    researchBidsContacts: apiResponse.getFilterAsArray(LK.LookupKeys.Contacts, true),
                    researchBidsRegions: apiResponse.getFilterAsArray(LK.LookupKeys.Regions, true),
                    researchBidsResults: apiResponse.getResultsArray(true),
                    researchBidsStatuses: apiResponse.getFilterAsArray(LK.LookupKeys.Statuses, true),
                    researchBidsStreetTypes: apiResponse.getFilterAsArray(LK.LookupKeys.StreetTypes, true),

                    researchBidsAssociationTypesMulti: apiResponse.getFilterAsArray(LK.LookupKeys.AssociationTypes, true),
                    researchBidsClientsMulti: apiResponse.getFilterAsArray(LK.LookupKeys.Clients, true),
                    researchBidsRegionsMulti: apiResponse.getFilterAsArray(LK.LookupKeys.Regions, true),
                    researchBidsStatusesMulti: apiResponse.getFilterAsArray(LK.LookupKeys.Statuses, true),
                    researchBidsStreetTypesMulti: apiResponse.getFilterAsArray(LK.LookupKeys.StreetTypes, true),
                };
            },
            update: {
                researchBidsAssociationTypes: UpdateToNext,
                researchBidsClients: UpdateToNext,
                researchBidsRegions: UpdateToNext,
                researchBidsResults: UpdateToNext,
                researchBidsStatuses: UpdateToNext,
                researchBidsStreetTypes: UpdateToNext,

                researchBidsAssociationTypesMulti: UpdateToNext,
                researchBidsClientsMulti: UpdateToNext,
                researchBidsRegionsMulti: UpdateToNext,
                researchBidsStatusesMulti: UpdateToNext,
                researchBidsStreetTypesMulti: UpdateToNext,
            },
        });
    },

    searchNewResearchBidsRequest: (
        url: string,
        accessToken: string,
        fromBidDate: string,
        toBidDate: string,
        fromCompletionDate: string,
        toCompletionDate: string,
        operator: string
    ) => {
        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: url,
            body: {
                fromBidDate: fromBidDate,
                toBidDate: toBidDate,
                fromCompletionDate: fromCompletionDate,
                toCompletionDate: toCompletionDate,
                operator: operator,
            },
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);
                return {
                    newResearchBidsResults: apiResponse.getResultsArray(true),
                };
            },
            update: {
                newResearchBidsResults: UpdateToNext,
            },
        });
    },

    searchOutstandingBidsFiltersRequest: (
        url: string,
        accessToken: string,
    ) => {
        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: url,
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);
                return {
                    outstandingBidsClients: apiResponse.getFilterAsArray(LK.LookupKeys.Clients, true),
                    outstandingBidsRegions: apiResponse.getFilterAsArray(LK.LookupKeys.Regions, true),
                    outstandingBidsStatuses: apiResponse.getFilterAsArray(LK.LookupKeys.Statuses, true),
                };
            },
            update: {
                outstandingBidsClients: UpdateToNext,
                outstandingBidsRegions: UpdateToNext,
                outstandingBidsStatuses: UpdateToNext,
            },
        });
    },

    searchOutstandingBidsRequest: (
        url: string,
        accessToken: string,
        fromBidDate: string,
        toBidDate: string,
        statusId: any,
        clientId: any,
        regionId: any,
        fromFollowUpDate: string,
        toFollowUpDate: string,
        unsolicitedBid: number,
        operator: string,
    ) => {
        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: url,
            body: {
                clientId: Formatters.int(clientId),
                fromFollowUpDate: fromFollowUpDate,
                toFollowUpDate: toFollowUpDate,
                fromBidDate: fromBidDate,
                operator: operator,
                regionId: Formatters.int(regionId),
                statusId: Formatters.int(statusId),
                toBidDate: toBidDate,
                unsolicitedBid: Formatters.int(unsolicitedBid),
            },
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);
                return {
                    outstandingBidsResults: apiResponse.getResultsArray(true),
                };
            },
            update: {
                outstandingBidsResults: UpdateToNext,
            },
        });
    },

    searchReminderBidsRequest: (
        url: string,
        accessToken: string,
        statusId: any,
        clientId: any,
        regionId: any,
        fromCompletionDate: string,
        toCompletionDate: string,
        fromSentDate: string,
        toSentDate: string,
        fromReminderDate: string,
        toReminderDate: string,
        unsolicitedBid: number,
        serviceLevelId: number,
        operator: string
    ) => {
        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: url,
            body: {
                clientId: Formatters.int(clientId),
                fromCompletionDate: fromCompletionDate,
                fromReminderDate: fromReminderDate,
                fromSentDate: fromSentDate,
                operator: operator,
                regionId: Formatters.int(regionId),
                serviceLevelId: Formatters.int(serviceLevelId),
                statusId: Formatters.int(statusId),
                toCompletionDate: toCompletionDate,
                toReminderDate: toReminderDate,
                toSentDate: toSentDate,
                unsolicitedBid: Formatters.int(unsolicitedBid),
            },
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);
                return {
                    reminderBidsClients: apiResponse.getFilterAsArray(LK.LookupKeys.Clients, true),
                    reminderBidsRegions: apiResponse.getFilterAsArray(LK.LookupKeys.Regions, true),
                    reminderBidsResults: apiResponse.getResultsArray(true),
                    reminderBidsServiceLevels: apiResponse.getFilterAsArray(LK.LookupKeys.ServiceLevels, true),
                    reminderBidsStatuses: apiResponse.getFilterAsArray(LK.LookupKeys.Statuses, true),
                };
            },
            update: {
                reminderBidsClients: UpdateToNext,
                reminderBidsRegions: UpdateToNext,
                reminderBidsResults: UpdateToNext,
                reminderBidsServiceLevels: UpdateToNext,
                reminderBidsStatuses: UpdateToNext,
            },
        });
    },

    searchWonJobsRequest: (
        url: string,
        accessToken: string,
        filterMode: number,
        operator: string,
    ) => {
        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: url,
            body: {
                operator: operator,
                filterMode: Formatters.int(filterMode),
            },
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);
                return {
                    wonJobsResults: apiResponse.getResultsArray(true),
                };
            },
            update: {
                wonJobsResults: UpdateToNext,
            },
        });
    },

    searchDefaultManagersRequest: (
        url: string,
        accessToken: string,
        operator: string,
    ) => {
        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: url,
            body: {
                operator: operator,
            },
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);
                return {
                    defaultManagersResults: apiResponse.getResultsArray(true),
                };
            },
            update: {
                defaultManagersResults: UpdateToNext,
            },
        });
    },

    getAssociationInventoryRequest: (url: string, accessToken: string) => {
        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: url,
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);
                return {
                    associationInventoryAssociation: apiResponse.getFieldAsObject('association'),
                    associationInventoryCurrentOrder: apiResponse.getFieldAsObject('currentOrder'),
                    associationInventoryInventory: apiResponse.getFieldAsArray('inventory', true),
                    associationInventoryOrderStatuses: apiResponse.getFieldAsArray('orderStatuses', true),
                    associationInventoryTemplates: apiResponse.getFieldAsArray('inventoryTemplates', true),
                    associationInventoryUserInventoryTemplates: apiResponse.getFieldAsArray('userInventoryTemplates', true),
                };
            },
            update: {
                associationInventoryAssociation: UpdateToNext,
                associationInventoryCurrentOrder: UpdateToNext,
                associationInventoryInventory: UpdateToNext,
                associationInventoryOrderStatuses: UpdateToNext,
                associationInventoryTemplates: UpdateToNext,
                associationInventoryUserInventoryTemplates: UpdateToNext,
            },
        });
    },

    getAssociationInventoryDetailRequest: (url: string, accessToken: string) => {
        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: url,
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);
                return {
                    associationInventoryDetailAssociation: apiResponse.getFieldAsObject('association'),
                    associationInventoryDetailAssociationPhotos: apiResponse.getFieldAsArray('associationPhotos'),
                    associationInventoryDetailAssociationPhotosTree: apiResponse.getFieldAsObject('associationPhotosTree'),
                    associationInventoryDetailAssociationPhotoFolders: apiResponse.getFieldAsArray('associationPhotoFolders'),
                    associationInventoryDetailInventory: apiResponse.getFieldAsObject('inventory'),
                    associationInventoryDetailInventoryResearch: apiResponse.getFieldAsArray('inventoryResearch'),
                    associationInventoryDetailAllInventory: apiResponse.getFieldAsObject('allInventory'),
                    associationInventoryDetailReplacementCosts: apiResponse.getFieldAsObject('replacementCosts'),
                    associationInventoryDetailComponents: apiResponse.getFieldAsObject('components'),
                    associationInventoryDetailComponentCategories: apiResponse.getFieldAsObject('componentCategories'),
                    associationInventoryDetailGroupComponents: apiResponse.getFieldAsObject('groupComponents'),
                    associationInventoryDetailCostSources: apiResponse.getFieldAsObject('costSources'),
                    associationInventoryDetailAuthUserGroups: apiResponse.getFieldAsObject('authUserGroups'),
                    associationInventoryDetailUserInventoryTemplate: apiResponse.getFieldAsObject('userInventoryTemplate'),
                };
            },
            update: {
                associationInventoryDetailAssociation: UpdateToNext,
                associationInventoryDetailAssociationPhotos: UpdateToNext,
                associationInventoryDetailAssociationPhotosTree: UpdateToNext,
                associationInventoryDetailAssociationPhotoFolders: UpdateToNext,
                associationInventoryDetailInventory: UpdateToNext,
                associationInventoryDetailInventoryResearch: UpdateToNext,
                associationInventoryDetailAllInventory: UpdateToNext,
                associationInventoryDetailReplacementCosts: UpdateToNext,
                associationInventoryDetailComponents: UpdateToNext,
                associationInventoryDetailComponentCategories: UpdateToNext,
                associationInventoryDetailGroupComponents: UpdateToNext,
                associationInventoryDetailCostSources: UpdateToNext,
                associationInventoryDetailAuthUserGroups: UpdateToNext,
                associationInventoryDetailUserInventoryTemplate: UpdateToNext,
            },
        });
    },

    getReserveStudyRequest: (url: string, accessToken: string) => {
        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: url,
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);
                return {
                    reserveStudyAssociation: apiResponse.getFieldAsObject('association'),
                    reserveStudyCurrentOrder: apiResponse.getFieldAsObject('currentOrder'),
                    reserveStudyCurrentOrderChart: apiResponse.getFieldAsObject('currentOrderChart'),
                    reserveStudyInventory: apiResponse.getFieldAsObject('inventory'),
                    reserveStudyOrders: apiResponse.getFieldAsObject('orders'),
                    reserveStudyArchivedCharts: apiResponse.getFieldAsObject('archivedCharts'),
                    reserveStudyUserResumes: apiResponse.getFieldAsObject('userResumes'),
                    reserveStudyAssociationPhotos: apiResponse.getFieldAsArray('associationPhotos'),
                    reserveStudyAssociationPhotoFolders: apiResponse.getFieldAsArray('associationPhotoFolders'),
                    reserveStudyAssociationPhotosTree: apiResponse.getFieldAsObject('associationPhotosTree'),
                };
            },
            update: {
                reserveStudyAssociation: UpdateToNext,
                reserveStudyCurrentOrder: UpdateToNext,
                reserveStudyCurrentOrderChart: UpdateToNext,
                reserveStudyInventory: UpdateToNext,
                reserveStudyOrders: UpdateToNext,
                reserveStudyArchivedCharts: UpdateToNext,
                reserveStudyUserResumes: UpdateToNext,
                reserveStudyAssociationPhotos: UpdateToNext,
                reserveStudyAssociationPhotoFolders: UpdateToNext,
                reserveStudyAssociationPhotosTree: UpdateToNext,
            },
        });
    },

    getMyAccountUserDetailRequest: (url: string, accessToken: string) => {
        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: url,
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);
                return {
                    myAccountUserDetail: apiResponse.getResponseObject(),
                };
            },
            update: {
                myAccountUserDetail: UpdateToNext,
            },
        });
    },

    getOrderDetailRequest: (url: string, accessToken: string) => {
        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: url,
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);
                return {
                    orderDetailOrder: apiResponse.getFieldAsObject('order.document'),
                    orderDetailOrderChart: apiResponse.getFieldAsObject('reserveStudyChart.document'),
                    orderDetailOrders: apiResponse.getFieldAsArray('orders.documents'),
                    orderDetailAssociation: apiResponse.getFieldAsObject('association'),
                };
            },
            update: {
                orderDetailOrder: UpdateToNext,
                orderDetailOrders: UpdateToNext,
                orderDetailOrderChart: UpdateToNext,
                orderDetailAssociation: UpdateToNext,
            },
        });
    },

    getEditOrderDetailRequest: (url: string, accessToken: string) => {
        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: url,
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);
                return {
                    editOrderDetailOrder: apiResponse.getFieldAsObject('order'),
                    editOrderDetailOrderChartDetail: apiResponse.getFieldAsObject('reserveStudyChart'),
                    editOrderDetailOrders: apiResponse.getFieldAsArray('orders'),
                    editOrderDetailAssociation: apiResponse.getFieldAsObject('association'),
                    editOrderDetailAssociations: apiResponse.getFieldAsArray('associations'),
                    editOrderDetailClients: apiResponse.getFieldAsArray('clients'),
                    editOrderDetailAssociationClient: apiResponse.getFieldAsObject('associationClient'),
                    editOrderDetailOrderClient: apiResponse.getFieldAsObject('orderClient'),
                    editOrderDetailUsers: apiResponse.getFieldAsArray('users'),
                    editOrderDetailStatuses: apiResponse.getFieldAsArray('statuses'),
                    editOrderDetailServiceLevels: apiResponse.getFieldAsArray('serviceLevels'),
                    editOrderDetailOrderServiceTypes: apiResponse.getFieldAsArray('orderServiceTypes'),
                    editOrderCompanies: apiResponse.getFieldAsArray('companies'),
                };
            },
            update: {
                editOrderDetailOrder: UpdateToNext,
                editOrderDetailOrders: UpdateToNext,
                editOrderDetailOrderChartDetail: UpdateToNext,
                editOrderDetailAssociation: UpdateToNext,
                editOrderDetailAssociations: UpdateToNext,
                editOrderDetailClients: UpdateToNext,
                editOrderDetailAssociationClient: UpdateToNext,
                editOrderDetailOrderClient: UpdateToNext,
                editOrderDetailUsers: UpdateToNext,
                editOrderDetailStatuses: UpdateToNext,
                editOrderDetailServiceLevels: UpdateToNext,
                editOrderDetailOrderServiceTypes: UpdateToNext,
                editOrderCompanies: UpdateToNext,
            },
        });
    },

    getEditComponentDetailRequest: (url: string, accessToken: string) => {
        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: url,
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);
                return {
                    editComponentDetailComponent: apiResponse.getFieldAsObject('component'),
                    editComponentDetailComponentReplacementCosts: apiResponse.getFieldAsArray('componentReplacementCosts'),
                    editComponentDetailComponentCategories: apiResponse.getFieldAsArray('componentCategories'),
                    editComponentDetailGroups: apiResponse.getFieldAsArray('groups'),
                    editComponentDetailGroupComponents: apiResponse.getFieldAsArray('groupComponents'),
                };
            },
            update: {
                editComponentDetailComponent: UpdateToNext,
                editComponentDetailComponentReplacementCosts: UpdateToNext,
                editComponentDetailComponentCategories: UpdateToNext,
                editComponentDetailGroups: UpdateToNext,
                editComponentDetailGroupComponents: UpdateToNext,
            },
        });
    },

    getOrderDataBidLetterRequest: (url: string, accessToken: string) => {
        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: url,
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);
                return {
                    orderBidLetterPdfOrder: apiResponse.getFieldAsObject('order'),
                    orderBidLetterPdfAssociation: apiResponse.getFieldAsObject('association'),
                    orderBidLetterPdfAssociationClient: apiResponse.getFieldAsObject('associationClient'),
                    orderBidLetterPdfOffices: apiResponse.getFieldAsArray('offices'),
                    orderBidLetterPdfOrderClient: apiResponse.getFieldAsObject('orderClient'),
                    orderBidLetterPdfServiceLevels: apiResponse.getFieldAsArray('serviceLevels'),
                    orderBidLetterPdfOrderManagerUser: apiResponse.getFieldAsObject('orderManagerUser'),
                    orderBidLetterPdfTextContents: apiResponse.getFieldAsObject('textContents'),
                };
            },
            update: {
                orderBidLetterPdfOrder: UpdateToNext,
                orderBidLetterPdfAssociation: UpdateToNext,
                orderBidLetterPdfAssociationClient: UpdateToNext,
                orderBidLetterPdfOffices: UpdateToNext,
                orderBidLetterPdfOrderClient: UpdateToNext,
                orderBidLetterPdfServiceLevels: UpdateToNext,
                orderBidLetterPdfOrderManagerUser: UpdateToNext,
                orderBidLetterPdfTextContents: UpdateToNext,
            },
        });
    },

    getOrdersDataBidLettersRequest: (url: string, accessToken: string) => {
        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: url,
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);
                return {
                    orderBidLetterPdfOrders: apiResponse.getFieldAsArray('orders'),
                    orderBidLetterPdfAssociations: apiResponse.getFieldAsArray('associations'),
                    orderBidLetterPdfClients: apiResponse.getFieldAsArray('clients'),
                    orderBidLetterPdfOffices: apiResponse.getFieldAsArray('offices'),
                    orderBidLetterPdfServiceLevels: apiResponse.getFieldAsArray('serviceLevels'),
                    orderBidLetterPdfOrderManagerUsers: apiResponse.getFieldAsArray('orderManagerUsers'),
                    orderBidLetterPdfTextContents: apiResponse.getFieldAsObject('textContents'),
                };
            },
            update: {
                orderBidLetterPdfOrders: UpdateToNext,
                orderBidLetterPdfAssociations: UpdateToNext,
                orderBidLetterPdfClients: UpdateToNext,
                orderBidLetterPdfOffices: UpdateToNext,
                orderBidLetterPdfServiceLevels: UpdateToNext,
                orderBidLetterPdfOrderManagerUsers: UpdateToNext,
                orderBidLetterPdfTextContents: UpdateToNext,
            },
        });
    },

    getEditRegionDetailRequest: (url: string, accessToken: string) => {
        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: url,
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);
                return {
                    editRegionDetailRegion: apiResponse.getFieldAsObject('region'),
                    editRegionDetailUsers: apiResponse.getFieldAsArray('users'),
                    editRegionDetailRegionOffices: apiResponse.getFieldAsArray('regionOffices'),
                    editRegionDetailOffices: apiResponse.getFieldAsArray('offices'),
                };
            },
            update: {
                editRegionDetailRegion: UpdateToNext,
                editRegionDetailUsers: UpdateToNext,
                editRegionDetailRegionOffices: UpdateToNext,
                editRegionDetailOffices: UpdateToNext,
            },
        });
    },

    getClientDetailRequest: (url: string, accessToken: string) => {
        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: url,
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);
                return {
                    clientDetailClient: apiResponse.getFieldAsObject('client'),
                    clientDetailAssociations: apiResponse.getFieldAsArray(LK.LookupKeys.Associations, true),
                };
            },
            update: {
                clientDetailClient: UpdateToNext,
                clientDetailAssociations: UpdateToNext,
            },
        });
    },

    getAssociationDetailRequest: (url: string, accessToken: string) => {
        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: url,
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);
                return {
                    associationDetailAssociation: apiResponse.getFieldAsObject('association'),
                    associationDetailAssociationCurrentOrderId: apiResponse.getFieldAsObject('currentOrderId'),
                    associationDetailAssociationPortalInvites: apiResponse.getFieldAsArray('portalInvites'),
                };
            },
            update: {
                associationDetailAssociation: UpdateToNext,
                associationDetailAssociationCurrentOrderId: UpdateToNext,
                associationDetailAssociationPortalInvites: UpdateToNext,
            },
        });
    },

    getLookupsByKeyRequest: (url: string, accessToken: string) => {
        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: url,
            transform: (data) => {
                let transformed = {
                    lookups: {

                    }
                };

                // Iterate & automatically merge any filterData into state
                let apiResponse = new ApiQueryResponse(data);

                transformed = _.set(transformed, 'lookups', apiResponse.getLookups(true));

                return transformed;
            },
            update: {
                lookups: UpdateToNext,
            },
        });
    },

    createClientMutation: (accessToken: string, client: any, optimistic: boolean = false) => {
        // if (optimistic) {
        //     queryConfig.optimisticUpdate = {
        //         addClientResult: () => client,
        //     };
        // }

        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: ApiEndpoints.getCreateClientUrl(),
            body: client,
            update: {
                addClientResult: UpdateToNext,
            },
        });
    },

    updateClientMutation: (accessToken: string, client: any, optimistic: boolean = false) => {
        // if (optimistic) {
        //     queryConfig.optimisticUpdate = {
        //         addClientResult: () => client,
        //     };
        // }

        // console.log('queries.updateAssociationMutation association', association);

        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: ApiEndpoints.getUpdateClientUrl(_.get(client, 'client.clientId')),
            body: client,
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);
                return {
                    clientDetailClient: apiResponse.getFieldAsObject('client.document'),
                };
            },
            update: {
                clientDetailClient: UpdateToNext,
            },
        });
    },

    updateClientContactMutation: (accessToken: string, clientId: number, contact: any, optimistic: boolean = false) => {
        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: ApiEndpoints.getUpdateClientContactUrl(clientId),
            body: contact,
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);
                return {
                    clientDetailClient: apiResponse.getResponseObject(),
                };
            },
            update: {
                clientDetailClient: UpdateToNext,
            },
        });
    },

    createClientContactMutation: (accessToken: string, clientId: number, contact: any, optimistic: boolean = false) => {
        // Submit request to api to insert/create a new client contactrecord

        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: ApiEndpoints.getCreateClientContactUrl(clientId),
            body: contact,
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);
                return {
                    clientDetailClient: apiResponse.getResponseObject()
                };
            },
            update: {
                clientDetailClient: UpdateToNext,
            },
        });
    },

    updateAssociationMutation: (accessToken: string, association: any, optimistic: boolean = false) => {
        // Submit request to api to insert/create a new association record

        // if (optimistic) {
        //     queryConfig.optimisticUpdate = {
        //         addClientResult: () => client,
        //     };
        // }

        // console.log('queries.updateAssociationMutation association', association);

        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: ApiEndpoints.getUpdateAssociationUrl(_.get(association, 'association.associationId')),
            body: association,
            update: {
                updateAssociationResult: UpdateToNext,
            },
        });
    },

    updateReserveStudyChartMutation: (accessToken: string, reserveStudyChart: any, optimistic: boolean = false) => {
        // console.log('updateReserveStudyChartMutation', reserveStudyChart);
        // Submit request to api to insert/create a new association record

        // if (optimistic) {
        //     queryConfig.optimisticUpdate = {
        //         addClientResult: () => client,
        //     };
        // }

        // console.log('queries.updateReserveStudyChartMutation reserveStudyChart', reserveStudyChart);

        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: ApiEndpoints.getUpdateReserveStudyChartUrl(_.get(reserveStudyChart, 'currentOrder.orderId')),
            body: reserveStudyChart,
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);
                return {
                    reserveStudyCurrentOrder: apiResponse.getFieldAsObject('order.document'),
                    reserveStudyCurrentOrderChart: apiResponse.getFieldAsObject('reserveStudyChart.document'),
                };
            },
            update: {
                // updateReserveStudyChartResult: UpdateToNext,
                reserveStudyCurrentOrder: UpdateToNext,
                reserveStudyCurrentOrderChart: UpdateToNext,
            },
        });
    },

    updateComponentReplacementCostsMutation: (accessToken: string, payload: any, optimistic: boolean = false) => {
        const componentId = Formatters.getInt(payload, 'component.componentId');

        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: ApiEndpoints.getUpdateComponentReplacementCostsUrl(componentId),
            body: payload,
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);

                return {
                    associationInventoryDetailReplacementCosts: apiResponse.getFieldAsObject('replacementCosts'),
                };
            },
            update: {
                associationInventoryDetailReplacementCosts: UpdateToNext,
            },
        });
    },

    updateAssociationInventoryMutation: (accessToken: string, associationInventoryData: any, optimistic: boolean = false) => {
        const assocId = Formatters.getInt(associationInventoryData, 'association.associationId');
        const invId = Formatters.getInt(associationInventoryData, 'inventory.inventoryId');
        
        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: ApiEndpoints.getUpdateAssociationInventoryUrl(assocId, invId),
            body: associationInventoryData,
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);

                return {
                    associationInventoryDetailInventory: apiResponse.getFieldAsObject('inventory.document'),
                    associationInventoryDetailAllInventory: apiResponse.getFieldAsObject('allInventory'),
                    associationInventoryDetailInventoryResearch: apiResponse.getFieldAsArray('inventoryResearch.documents'),
                };
            },
            update: {
                associationInventoryDetailInventory: UpdateToNext,
                associationInventoryDetailAllInventory: UpdateToNext,
                associationInventoryDetailInventoryResearch: MergeWithPre,
            },
        });
    },

    newAssociationInventoryMutation: (accessToken: string, associationInventoryData: any, optimistic: boolean = false) => {
        const assocId = Formatters.getInt(associationInventoryData, 'association.associationId');
        const invId = Formatters.getInt(associationInventoryData, 'inventory.inventoryId');

        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: ApiEndpoints.getNewAssociationInventoryUrl(assocId, invId),
            body: associationInventoryData,
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);

                return {
                    associationInventoryDetailInventoryNew: apiResponse.getResponseObject()
                };
            },
            update: {
                associationInventoryDetailInventoryNew: UpdateToNext,
            },
        });
    },

    deleteAssociationInventoryMutation: (accessToken: string, associationInventoryData: any, optimistic: boolean = false) => {
        const assocId = Formatters.getInt(associationInventoryData, 'association.associationId');
        const invId = Formatters.getInt(associationInventoryData, 'inventory.inventoryId');

        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: ApiEndpoints.getDeleteAssociationInventoryUrl(assocId, invId),
            body: associationInventoryData,
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);

                return {
                    associationInventoryDetailInventoryDelete: apiResponse.getResponseObject()
                };
            },
            update: {
                associationInventoryDetailInventoryDelete: UpdateToNext,
            },
        });
    },

    newAssociationInventoryResearchMutation: (accessToken: string, payload: any, optimistic: boolean = false) => {
        const assocId = Formatters.getInt(payload, 'association.associationId');
        const invId = Formatters.getInt(payload, 'inventory.inventoryId');

        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: ApiEndpoints.getNewAssociationInventoryResearchUrl(assocId, invId),
            body: payload,
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);

                return {
                    associationInventoryDetailInventoryResearch: apiResponse.getFieldAsArray('inventoryResearch'),
                };
            },
            update: {
                associationInventoryDetailInventoryResearch: MergeWithPre,
            },
        });
    },

    deleteAssociationInventoryResearchMutation: (accessToken: string, payload: any, optimistic: boolean = false) => {
        const assocId = Formatters.getInt(payload, 'association.associationId');
        const invId = Formatters.getInt(payload, 'inventory.inventoryId');
        const researchId = Formatters.getInt(payload, 'research.researchId');

        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: ApiEndpoints.getDeleteAssociationInventoryResearchUrl(assocId, invId, researchId),
            body: payload,
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);

                return {
                    associationInventoryDetailInventoryResearch: apiResponse.getFieldAsArray('inventoryResearch.documents'),
                };
            },
            update: {
                associationInventoryDetailInventoryResearch: (prev) => _.filter(prev, (ir) => ir.researchId !== researchId),
            },
        });
    },

    newAssociationInventorySubgroupMutation: (accessToken: string, mutateData: any, optimistic: boolean = false) => {
        const assocId = Formatters.getInt(mutateData, 'association.associationId');

        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: ApiEndpoints.getNewAssociationInventorySubgroupUrl(assocId),
            body: mutateData,
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);

                return {
                    associationInventoryAssociation: apiResponse.getResponseObject()
                };
            },
            update: {
                associationInventoryAssociation: UpdateToNext,
            },
        });
    },

    getUserInventoryTemplateRequest: (url: string, accessToken: string) => {
        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: url,
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);
                return {
                    userInvTemplateUser: apiResponse.getFieldAsObject('user'),
                    userInvTemplateUserInventoryTemplate: apiResponse.getFieldAsObject('userInventoryTemplate'),
                    userInvItemsWithAssocData: apiResponse.getFieldAsObject('invItemsWithAssocData'),
                    userTemplateAssociation: apiResponse.getFieldAsObject('templateAssociation'),
                };
            },
            update: {
                userInvTemplateUser: UpdateToNext,
                userInvTemplateUserInventoryTemplate: UpdateToNext,
                userInvItemsWithAssocData: UpdateToNext,
                userTemplateAssociation: UpdateToNext,
            },
        });
    },

    newUserInventoryTemplateMutation: (accessToken: string, mutateData: any, optimistic: boolean = false) => {
        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: ApiEndpoints.getNewUserInventoryTemplateUrl(),
            body: mutateData,
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);

                return {
                    // 20191201 Refactored to expect userInventoryTemplates.documents response
                    // userInventoryTemplates: apiResponse.getResponseObject(),

                    associationInventoryUserInventoryTemplates: apiResponse.getFieldAsArray('userInventoryTemplates.documents', true),
                    userInventoryTemplateNew: apiResponse.getFieldAsObject('userInventoryTemplate.document'),
                };
            },
            update: {
                // 20191201 Refactored to expect userInventoryTemplates.documents response
                // userInventoryTemplates: UpdateToNext,

                associationInventoryUserInventoryTemplates: UpdateToNext,
                userInventoryTemplateNew: UpdateToNext,
            },
        });
    },

    applyUserInventoryTemplateMutation: (accessToken: string, mutateData: any, optimistic: boolean = false) => {
        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: ApiEndpoints.getApplyUserInventoryTemplateUrl(),
            body: mutateData,
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);

                return {
                    associationInventoryAssociation: apiResponse.getFieldAsObject('association.document'),
                    associationInventoryInventory: apiResponse.getFieldAsArray('inventory.documents', true),
                };
            },
            update: {
                associationInventoryAssociation: UpdateToNext,
                associationInventoryInventory: UpdateToNext,
            },
        });
    },

    updateUserInventoryTemplateMutation: (accessToken: string, objData: any, optimistic: boolean = false) => {
        const userInvTemplateObjId = Formatters.getStr(objData, 'userInventoryTemplateObjId');

        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: ApiEndpoints.getUpdateUserInventoryTemplateUrl(userInvTemplateObjId),
            body: objData,
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);

                return {
                    editUserInventoryTemplateObj: apiResponse.getFieldAsObject('userInventoryTemplate.document'),
                };
            },
            update: {
                editUserInventoryTemplateObj: UpdateToNext,
            },
        });
    },

    renameUserInventoryTemplateMutation: (accessToken: string, objData: any, optimistic: boolean = false) => {
        const userInvTemplateObjId = Formatters.getStr(objData, 'userInventoryTemplateObjId');

        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: ApiEndpoints.getRenameUserInventoryTemplateUrl(userInvTemplateObjId),
            body: objData,
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);

                return {
                    renameUserInventoryTemplateObj: apiResponse.getFieldAsObject('userInventoryTemplate.document'),
                };
            },
            update: {
                editUserInventoryTemplateObj: UpdateToNext,
            },
        });
    },

    deleteUserInventoryTemplateMutation: (accessToken: string, objData: any, optimistic: boolean = false) => {
        const userInvTemplateObjId = Formatters.getStr(objData, 'userInventoryTemplateObjId');

        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: ApiEndpoints.getDeleteUserInventoryTemplateUrl(userInvTemplateObjId),
            body: objData,
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);

                return {
                    deleteUserInventoryTemplateObj: apiResponse.getFieldAsObject('userInventoryTemplate.document'),
                };
            },
            update: {
                editUserInventoryTemplateObj: UpdateToNext,
            },
        });
    },

    deleteUserInventoryTemplateItemMutation: (accessToken: string, objData: any, optimistic: boolean = false) => {
        const userInvTemplateObjId = Formatters.getStr(objData, 'userInventoryTemplateObjId');
        const userInvTemplateInvItemObjId = Formatters.getStr(objData, 'userInventoryTemplateInventoryItemObjId');

        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: ApiEndpoints.getDeleteUserInventoryTemplateItemUrl(userInvTemplateObjId, userInvTemplateInvItemObjId),
            body: objData,
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);

                return {
                    editUserInventoryTemplateObj: apiResponse.getFieldAsObject('userInventoryTemplate.document'),
                };
            },
            update: {
                editUserInventoryTemplateObj: UpdateToNext,
            },
        });
    },

    updateAssociationInventorySubgroupMutation: (accessToken: string, mutateData: any, optimistic: boolean = false) => {
        const assocId = Formatters.getInt(mutateData, 'association.associationId');

        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: ApiEndpoints.getUpdateAssociationInventorySubgroupUrl(assocId),
            body: mutateData,
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);

                return {
                    associationInventoryAssociation: apiResponse.getFieldAsObject('association.document'),
                    associationInventoryInventory: apiResponse.getFieldAsArray('inventories.documents'),
                };
            },
            update: {
                associationInventoryAssociation: UpdateToNext,
                associationInventoryInventory: UpdateToNext,
            },
        });
    },

    deleteAssociationInventorySubgroupMutation: (accessToken: string, mutateData: any, optimistic: boolean = false) => {
        const assocId = Formatters.getInt(mutateData, 'association.associationId');

        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: ApiEndpoints.getDeleteAssociationInventorySubgroupUrl(assocId),
            body: mutateData,
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);

                return {
                    associationInventoryAssociation: apiResponse.getFieldAsObject('association.document'),
                    associationInventoryInventory: apiResponse.getFieldAsArray('inventories.documents'),
                };
            },
            update: {
                associationInventoryAssociation: UpdateToNext,
                associationInventoryInventory: UpdateToNext,
            },
        });
    },

    duplicateAssociationInventorySubgroupMutation: (accessToken: string, mutateData: any, optimistic: boolean = false) => {
        const assocId = Formatters.getInt(mutateData, 'association.associationId');

        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: ApiEndpoints.getDuplicateAssociationInventorySubgroupUrl(assocId),
            body: mutateData,
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);

                return {
                    associationInventoryAssociation: apiResponse.getFieldAsObject('association.document'),
                    associationInventoryInventory: apiResponse.getFieldAsArray('inventory.documents'),
                };
            },
            update: {
                associationInventoryAssociation: UpdateToNext,
                associationInventoryInventory: UpdateToNext,
            },
        });
    },

    duplicateAssociationInventoryMutation: (accessToken: string, associationInventoryData: any, optimistic: boolean = false) => {
        const assocId = Formatters.getInt(associationInventoryData, 'association.associationId');
        const invId = Formatters.getInt(associationInventoryData, 'inventory.inventoryId');

        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: ApiEndpoints.getDuplicateAssociationInventoryUrl(assocId, invId),
            body: associationInventoryData,
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);

                return {
                    associationInventoryDetailInventoryDuplicate: apiResponse.getResponseObject()
                };
            },
            update: {
                associationInventoryDetailInventoryDuplicate: UpdateToNext,
            },
        });
    },

    updateAssociationInventoryItemsMutation: (accessToken: string, mutateData: any, optimistic: boolean = false) => {
        const assocId = Formatters.getInt(mutateData, 'association.associationId');

        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: ApiEndpoints.getUpdateAssociationInventoryItemsUrl(assocId),
            body: mutateData,
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);

                return {
                    associationInventoryAssociation: apiResponse.getFieldAsObject('association.document'),
                    associationInventoryInventory: apiResponse.getFieldAsArray('inventories.documents'),
                };
            },
            update: {
                associationInventoryAssociation: UpdateToNext,
                associationInventoryInventory: UpdateToNext,
            },
        });
    },

    deleteAssociationInventoryItemsMutation: (accessToken: string, mutateData: any, optimistic: boolean = false) => {
        const assocId = Formatters.getInt(mutateData, 'association.associationId');

        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: ApiEndpoints.getDeleteAssociationInventoryItemsUrl(assocId),
            body: mutateData,
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);

                return {
                    associationInventoryAssociation: apiResponse.getFieldAsObject('association.document'),
                    associationInventoryInventory: apiResponse.getFieldAsArray('inventories.documents'),
                };
            },
            update: {
                associationInventoryAssociation: UpdateToNext,
                associationInventoryInventory: UpdateToNext,
            },
        });
    },

    updateOrderMutation: (accessToken: string, orderData: any, optimistic: boolean = false) => {
        const orderId = Formatters.getInt(orderData, 'order.orderId');

        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: ApiEndpoints.getUpdateOrderUrl(orderId),
            body: orderData,
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);

                return {
                    associationInventoryCurrentOrder: apiResponse.getFieldAsObject('order.document'),
                    associationInventoryInventory: apiResponse.getFieldAsArray('inventory.documents', true),
                    editOrderDetailOrder: apiResponse.getFieldAsObject('order.document'),
                    editOrderDetailOrderChartDetail: apiResponse.getFieldAsObject('reserveStudyChart'),
                };
            },
            update: {
                associationInventoryCurrentOrder: UpdateToNext,
                associationInventoryInventory: UpdateToNext,
                editOrderDetailOrder: UpdateToNext,
                editOrderDetailOrderChartDetail: UpdateToNext,
            },
        });
    },

    updateOrdersSetAsPaidMutation: (accessToken: string, orderObjIds: any, optimistic: boolean = false) => {
        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: ApiEndpoints.getUpdateOrdersSetAsPaidUrl(),
            body: orderObjIds,
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);

                return {
                    updateOrdersSetAsPaidOrders: apiResponse.getFieldAsArray('orders.documents'),
                };
            },
            update: {
                updateOrdersSetAsPaidOrders: UpdateToNext,
            },
        });
    },

    deleteOrderMutation: (accessToken: string, orderData: any, optimistic: boolean = false) => {
        const orderId = Formatters.getInt(orderData, 'order.orderId');

        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: ApiEndpoints.getDeleteOrderUrl(orderId),
            body: orderData,
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);

                return {
                    editOrderDetailOrder: apiResponse.getFieldAsObject('order.document'),
                };
            },
            update: {
                editOrderDetailOrder: UpdateToNext,
            },
        });
    },

    newOrderMutation: (accessToken: string, orderData: any, optimistic: boolean = false) => {
        const associationId = Formatters.getInt(orderData, 'association.associationId', -1);
        const clientId = Formatters.getInt(orderData, 'client.clientId', -1);

        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: ApiEndpoints.getNewOrderUrl(associationId, clientId),
            body: orderData,
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);

                return {
                    newOrderDetail: apiResponse.getResponseObject()
                };
            },
            update: {
                newOrderDetail: UpdateToNext,
            },
        });
    },

    createNext3YearPlanSeqOrderMutation: (accessToken: string, orderData: any, optimistic: boolean = false) => {
        const associationId = Formatters.getInt(orderData, 'association.associationId', -1);
        const clientId = Formatters.getInt(orderData, 'client.clientId', -1);
        const orderId = Formatters.getInt(orderData, 'order.orderId', -1);

        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: ApiEndpoints.getCreateNext3YearPlanSeqOrderUrl(orderId),
            body: orderData,
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);

                return {
                    newOrderDetail: apiResponse.getResponseObject()
                };
            },
            update: {
                newOrderDetail: UpdateToNext,
            },
        });
    },

    newInventoryComponentMutation: (accessToken: string, mutateData: any, optimistic: boolean = false) => {
        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: ApiEndpoints.getNewInventoryComponentUrl('new'),
            body: mutateData,
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);

                return {
                    newInventoryComponent: apiResponse.getResponseObject()
                };
            },
            update: {
                newInventoryComponent: UpdateToNext,
            },
        });
    },

    updateWonJobsMutation: (accessToken: string, mutateData: any, optimistic: boolean = false) => {
        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: ApiEndpoints.getUpdateWonJobsUrl(),
            body: mutateData,
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);

                return {
                    updateWonJobs: apiResponse.getFieldAsArray('orders.documents'),
                };
            },
            update: {
                updateWonJobs: UpdateToNext,
            },
        });
    },

    updateOutstandingBidMutation: (accessToken: string, mutateData: any, optimistic: boolean = false) => {
        const orderId = Formatters.getInt(mutateData, 'updateOrder.orderId');

        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: ApiEndpoints.getUpdateOutstandingBidUrl(orderId),
            body: mutateData,
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);
                console.log(`updateOutstandingBidMutation apiResponse`, { apiResponse });

                return {
                    // associationInventoryCurrentOrder: apiResponse.getFieldAsObject('order.document'),
                    // associationInventoryInventory: apiResponse.getFieldAsArray('inventory.documents', true),
                    // editOrderDetailOrder: apiResponse.getFieldAsObject('order.document'),
                };
            },
            update: {
                // associationInventoryCurrentOrder: UpdateToNext,
                // associationInventoryInventory: UpdateToNext,
                // editOrderDetailOrder: UpdateToNext,
            },
        });
    },

    updateReminderBidMutation: (accessToken: string, mutateData: any, optimistic: boolean = false) => {
        console.log(`updateRminderBidMutation call`, { mutateData });

        const orderId = Formatters.getInt(mutateData, 'updateOrder.orderId');

        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: ApiEndpoints.getUpdateReminderBidUrl(orderId),
            body: mutateData,
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);
                console.log(`updateReminderBidMutation apiResponse`, { apiResponse });

                return {
                    // associationInventoryCurrentOrder: apiResponse.getFieldAsObject('order.document'),
                    // associationInventoryInventory: apiResponse.getFieldAsArray('inventory.documents', true),
                    // editOrderDetailOrder: apiResponse.getFieldAsObject('order.document'),
                };
            },
            update: {
                // associationInventoryCurrentOrder: UpdateToNext,
                // associationInventoryInventory: UpdateToNext,
                // editOrderDetailOrder: UpdateToNext,
            },
        });
    },

    setBidsSentMutation: (accessToken: string, mutateData: any, optimistic: boolean = false) => {
        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: ApiEndpoints.getSetBidsSentUrl(),
            body: mutateData,
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);

                return {
                    searchPreparedBidsResults: apiResponse.getFieldAsArray('orders.documents'),
                };
            },
            update: {
                searchPreparedBidsResults: UpdateToNext,
            },
        });
    },

    updateReminderBidsReminderDateMutation: (accessToken: string, mutateData: any, optimistic: boolean = false) => {
        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: ApiEndpoints.getUpdateReminderBidsReminderDateUrl(),
            body: mutateData,
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);

                return {
                    updateReminderBidsOrders: apiResponse.getFieldAsArray('orders.documents'),
                };
            },
            update: {
                updateReminderBidsOrders: UpdateToNext,
            },
        });
    },

    updateReminderBidsSendReminderEmailMutation: (accessToken: string, mutateData: any, optimistic: boolean = false) => {
        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: ApiEndpoints.getUpdateReminderBidsSendReminderEmailUrl(),
            body: mutateData,
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);

                return {
                    updateReminderBidsOrders: apiResponse.getFieldAsArray('orders.documents'),
                };
            },
            update: {
                updateReminderBidsOrders: UpdateToNext,
            },
        });
    },

    updateReminderBids3YearPlanStatusMutation: (accessToken: string, mutateData: any, optimistic: boolean = false) => {
        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: ApiEndpoints.getUpdateReminderBids3YearPlanStatusUrl(),
            body: mutateData,
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);

                return {
                    updateReminderBidsOrders: apiResponse.getFieldAsArray('orders.documents'),
                };
            },
            update: {
                updateReminderBidsOrders: UpdateToNext,
            },
        });
    },

    updateLookupObjMutation: (accessToken: string, objData: any, optimistic: boolean = false) => {
        const lookupObjId = Formatters.getStr(objData, 'obj._id');
        const lookupTableName = Formatters.getStr(objData, 'tableName');

        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: ApiEndpoints.getUpdateLookupObjUrl(lookupTableName, lookupObjId),
            body: objData,
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);

                return {
                    editLookupObj: apiResponse.getFieldAsObject('lookupObject.document'),
                    editLookupObjAssociations: apiResponse.getFieldAsArray('associations.documents'),
                    editLookupObjOrders: apiResponse.getFieldAsArray('orders.documents'),
                };
            },
            update: {
                editLookupObj: UpdateToNext,
                editLookupObjAssociations: UpdateToNext,
                editLookupObjOrders: UpdateToNext,
            },
        });
    },

    newLookupObjMutation: (accessToken: string, objData: any, optimistic: boolean = false) => {
        const lookupTableName = Formatters.getStr(objData, 'tableName');

        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: ApiEndpoints.getNewLookupObjUrl(lookupTableName),
            body: objData,
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);

                return {
                    editLookupObjNew: apiResponse.getFieldAsObject('lookupObject.document'),
                };
            },
            update: {
                editLookupObjNew: UpdateToNext,
            },
        });
    },

    deleteLookupObjMutation: (accessToken: string, objData: any, optimistic: boolean = false) => {
        const lookupObjId = Formatters.getStr(objData, 'obj._id');
        const lookupTableName = Formatters.getStr(objData, 'tableName');

        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: ApiEndpoints.getDeleteLookupObjUrl(lookupTableName, lookupObjId),
            body: objData,
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);

                return {
                    editLookupObjDelete: apiResponse.getFieldAsObject('lookupObject.document'),
                    editLookupObjDeleteAssociations: apiResponse.getFieldAsArray('associations.documents'),
                    editLookupObjDeleteOrders: apiResponse.getFieldAsArray('orders.documents'),
                };
            },
            update: {
                editLookupObjDelete: UpdateToNext,
                editLookupObjDeleteAssociations: UpdateToNext,
                editLookupObjDeleteOrders: UpdateToNext,
            },
        });
    },

    updateComponentMutation: (accessToken: string, objData: any, optimistic: boolean = false) => {
        const componentObjId = Formatters.getStr(objData, 'componentObjId');

        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: ApiEndpoints.getUpdateComponentUrl(componentObjId),
            body: objData,
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);

                return {
                    // component: apiResponse.getFieldAsObject('component.document'),
                    editComponentDetailComponent: apiResponse.getFieldAsObject('component.document'),
                };
            },
            update: {
                // component: UpdateToNext,
                editComponentDetailComponent: UpdateToNext,
            },
        });
    },

    updateReplacementCostMutation: (accessToken: string, objData: any, optimistic: boolean = false) => {
        const replacementCostObjId = Formatters.getStr(objData, 'replacementCostObjId');

        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: ApiEndpoints.getUpdateReplacementCostUrl(replacementCostObjId),
            body: objData,
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);

                return {
                    replacementCost: apiResponse.getFieldAsObject('replacementCost.document'),
                };
            },
            update: {
                replacementCost: UpdateToNext,
            },
        });
    },

    newReplacementCostMutation: (accessToken: string, objData: any, optimistic: boolean = false) => {
        const componentObjId = Formatters.getStr(objData, 'componentObjId');

        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: ApiEndpoints.getNewReplacementCostUrl(componentObjId),
            body: objData,
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);

                return {
                    replacementCost: apiResponse.getFieldAsObject('replacementCost.document'),
                };
            },
            update: {
                replacementCost: UpdateToNext,
            },
        });
    },

    deleteReplacementCostMutation: (accessToken: string, objData: any, optimistic: boolean = false) => {
        const replacementCostObjId = Formatters.getStr(objData, 'replacementCostObjId');

        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: ApiEndpoints.getDeleteReplacementCostUrl(replacementCostObjId),
            body: objData,
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);

                return {
                    replacementCost: apiResponse.getFieldAsObject('replacementCost.document'),
                };
            },
            update: {
                replacementCost: UpdateToNext,
            },
        });
    },

    newStandardEvaluationMutation: (accessToken: string, objData: any, optimistic: boolean = false) => {
        const componentObjId = Formatters.getStr(objData, 'componentObjId');

        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: ApiEndpoints.getNewStandardEvaluationUrl(componentObjId),
            body: objData,
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);

                return {
                    groupComponent: apiResponse.getFieldAsObject('groupComponent.document'),
                };
            },
            update: {
                groupComponent: UpdateToNext,
            },
        });
    },

    updateStandardEvaluationMutation: (accessToken: string, objData: any, optimistic: boolean = false) => {
        const componentObjId = Formatters.getStr(objData, 'componentObjId');

        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: ApiEndpoints.getUpdateStandardEvaluationUrl(componentObjId),
            body: objData,
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);

                return {
                    groupComponent: apiResponse.getFieldAsObject('groupComponent.document'),
                };
            },
            update: {
                groupComponent: UpdateToNext,
            },
        });
    },

    deleteStandardEvaluationMutation: (accessToken: string, objData: any, optimistic: boolean = false) => {
        const componentObjId = Formatters.getStr(objData, 'componentObjId');

        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: ApiEndpoints.getDeleteStandardEvaluationUrl(componentObjId),
            body: objData,
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);

                return {
                    groupComponent: apiResponse.getFieldAsObject('groupComponent.document'),
                };
            },
            update: {
                groupComponent: UpdateToNext,
            },
        });
    },

    updateUserMutation: (accessToken: string, userData: any, optimistic: boolean = false) => {
        const username = Formatters.getStr(userData, 'user.username');

        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: ApiEndpoints.getUpdateUserUrl(username),
            body: userData,
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);

                return {
                    userDetailUser: apiResponse.getFieldAsObject('user.document'),
                    userDetailUserResume: apiResponse.getFieldAsObject('userResume.document'),
                };
            },
            update: {
                userDetailUser: UpdateToNext,
                userDetailUserResume: UpdateToNext,
            },
        });
    },

    activateUserMutation: (accessToken: string, userData: any, optimistic: boolean = false) => {
        const userObjId = Formatters.getStr(userData, '_id');

        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: ApiEndpoints.getUserActivationUrl(userObjId),
            body: userData,
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);

                return {
                    activationUser: apiResponse.getFieldAsObject('user.document'),
                };
            },
            update: {
                activationUser: UpdateToNext,
            },
        });
    },

    newClientInviteMutation: (accessToken: string, clientInviteData: any, optimistic: boolean = false) => {
        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: ApiEndpoints.getNewClientInviteUrl(),
            body: clientInviteData,
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);

                return {
                    newClientInvites: apiResponse.getFieldAsArray('invites.documents')
                };
            },
            update: {
                newClientInvites: UpdateToNext,
            },
        });
    },

    updateReportScenarioMutation: (accessToken: string, scenarioData: any, optimistic: boolean = false) => {
        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: ApiEndpoints.getUpdateReportScenarioUrl(),
            body: scenarioData,
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);

                return {
                    newReportScenario: apiResponse.getFieldAsObject('reportScenario.document'),
                    newReportScenarioPortalUser: apiResponse.getFieldAsObject('portalUser.document'),
                    reportAssociationVisibleScenarios: apiResponse.getFieldAsArray('visibleScenarios.documents'),
                };
            },
            update: {
                newReportScenario: UpdateToNext,
                newReportScenarioPortalUser: UpdateToNext,
                reportAssociationVisibleScenarios: UpdateToNext,
            },
        });
    },

    copyReportScenarioMutation: (accessToken: string, scenarioData: any, optimistic: boolean = false) => {
        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: ApiEndpoints.getCopyReportScenarioUrl(),
            body: scenarioData,
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);

                return {
                    newReportScenario: apiResponse.getFieldAsObject('reportScenario.document'),
                    newReportScenarioPortalUser: apiResponse.getFieldAsObject('portalUser.document'),
                    reportAssociationVisibleScenarios: apiResponse.getFieldAsArray('visibleScenarios.documents'),
                };
            },
            update: {
                newReportScenario: UpdateToNext,
                newReportScenarioPortalUser: UpdateToNext,
                reportAssociationVisibleScenarios: UpdateToNext,
            },
        });
    },

    deleteReportScenarioMutation: (accessToken: string, scenarioData: any, optimistic: boolean = false) => {
        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: ApiEndpoints.getDeleteReportScenarioUrl(),
            body: scenarioData,
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);

                return {
                    // newReportScenario: apiResponse.getFieldAsObject('reportScenario.document'),
                    newReportScenarioPortalUser: apiResponse.getFieldAsObject('portalUser.document'),
                    reportAssociationVisibleScenarios: apiResponse.getFieldAsArray('visibleScenarios.documents'),
                };
            },
            update: {
                // newReportScenario: UpdateToNext,
                newReportScenarioPortalUser: UpdateToNext,
                reportAssociationVisibleScenarios: UpdateToNext,
            },
        });
    },

    toggleClientInviteMutation: (accessToken: string, clientInviteData: any, optimistic: boolean = false) => {
        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: ApiEndpoints.getToggleClientInviteUrl(),
            body: clientInviteData,
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);

                return {
                    reportAssociationPortalInvites: apiResponse.getFieldAsArray('associationPortalInvites'),
                };
            },
            update: {
                reportAssociationPortalInvites: UpdateToNext,
            },
        });
    },

    resendClientInviteMutation: (accessToken: string, clientInviteData: any, optimistic: boolean = false) => {
        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: ApiEndpoints.getResendClientInviteUrl(),
            body: clientInviteData,
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);

                return {
                    // reportAssociationPortalInvites: apiResponse.getFieldAsArray('associationPortalInvites'),
                };
            },
            update: {
                // reportAssociationPortalInvites: UpdateToNext,
            },
        });
    },

    newClientMutation: (accessToken: string, clientData: any, optimistic: boolean = false) => {
        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: ApiEndpoints.getNewClientUrl(),
            body: clientData,
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);

                return {
                    newClientDetail: apiResponse.getResponseObject()
                };
            },
            update: {
                newClientDetail: UpdateToNext,
            },
        });
    },

    newAssociationMutation: (accessToken: string, associationData: any, optimistic: boolean = false) => {
        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: ApiEndpoints.getNewAssociationUrl(),
            body: associationData,
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);

                return {
                    newAssociationDetail: apiResponse.getResponseObject()
                };
            },
            update: {
                newAssociationDetail: UpdateToNext,
            },
        });
    },

    deleteAssociationMutation: (accessToken: string, orderData: any, optimistic: boolean = false) => {
        const assocId = Formatters.getInt(orderData, 'order.assocId');

        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: ApiEndpoints.getDeleteAssociationUrl(assocId),
            body: orderData,
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);

                return {
                    deleteAssociationDetail: apiResponse.getResponseObject(),
                };
            },
            update: {
                deleteAssociationDetail: UpdateToNext,
            },
        });
    },

    newUserMutation: (accessToken: string, userData: any, optimistic: boolean = false) => {
        // const username = Formatters.getInt(userData, 'username');

        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: ApiEndpoints.getNewUserUrl(),
            body: userData,
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);

                return {
                    newUserDetail: apiResponse.getResponseObject()
                };
            },
            update: {
                newUserDetail: UpdateToNext,
            },
        });
    },

    newUserResumeMutation: (accessToken: string, userData: any, optimistic: boolean = false) => {
        // const username = Formatters.getInt(userData, 'username');

        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: ApiEndpoints.getNewUserResumeUrl(),
            body: userData,
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);

                return {
                    newUserDetail: apiResponse.getResponseObject()
                };
            },
            update: {
                newUserDetail: UpdateToNext,
            },
        });
    },

    updateRegionMutation: (accessToken: string, regionData: any, optimistic: boolean = false) => {
        const regionId = Formatters.getInt(regionData, 'region.regionId');

        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: ApiEndpoints.getUpdateRegionUrl(regionId),
            body: regionData,
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);

                return {
                    editRegionDetailRegion: apiResponse.getFieldAsObject('region.document'),
                    editRegionDetailOffices: apiResponse.getFieldAsArray('offices.documents'),
                };
            },
            update: {
                editRegionDetailRegion: UpdateToNext,
                editRegionDetailOffices: UpdateToNext,
            }
        });
    },

    getReportForAssociationRequest: (url: string, accessToken: string) => {
        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: url,
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);
                return {
                    reportAssociation: apiResponse.getFieldAsObject('association'),
                    reportAssociationCurrentOrder: apiResponse.getFieldAsObject('currentOrder'),
                    reportAssociationCurrentOrderChart: apiResponse.getFieldAsObject('currentOrderChart'),
                    reportAssociationInventory: apiResponse.getFieldAsArray('inventory'),
                    reportAssociationScenarios: apiResponse.getFieldAsArray('scenarios'),
                    reportAssociationUserResumes: apiResponse.getFieldAsArray('userResumes'),
                    reportAssociationPortalInvites: apiResponse.getFieldAsArray('portalInvites'),
                    reportAssociationVisibleScenarios: apiResponse.getFieldAsArray('visibleScenarios'),
                };
            },
            update: {
                reportAssociation: UpdateToNext,
                reportAssociationCurrentOrder: UpdateToNext,
                reportAssociationCurrentOrderChart: UpdateToNext,
                reportAssociationInventory: UpdateToNext,
                reportAssociationScenarios: UpdateToNext,
                reportAssociationUserResumes: UpdateToNext,
                reportAssociationPortalInvites: UpdateToNext,
                reportAssociationVisibleScenarios: UpdateToNext,
            },
        });
    },

    getUserDetailRequest: (url: string, accessToken: string) => {
        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: url,
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);
                return {
                    userDetailUser: apiResponse.getFieldAsObject('user'),
                    userDetailUserResume: apiResponse.getFieldAsObject('userResume'),
                    userDetailRoles: apiResponse.getFieldAsArray('roles'),
                    userDetailRegions: apiResponse.getFieldAsArray('regions'),
                    userDetailGroups: apiResponse.getFieldAsArray('userGroups'),
                    userDetailAllGroups: apiResponse.getFieldAsArray('allGroups'),
                    userDetailUsers: apiResponse.getFieldAsArray('users'),
                    userDetailPortalInvites: apiResponse.getFieldAsArray('portalInvites'),
                    userDetailUserInventoryTemplates: apiResponse.getFieldAsArray('userInventoryTemplates'),
                };
            },
            update: {
                userDetailUser: UpdateToNext,
                userDetailUserResume: UpdateToNext,
                userDetailRoles: UpdateToNext,
                userDetailRegions: UpdateToNext,
                userDetailUsers: UpdateToNext,
                userDetailGroups: UpdateToNext,
                userDetailAllGroups: UpdateToNext,
                userDetailPortalInvites: UpdateToNext,
                userDetailUserInventoryTemplates: UpdateToNext,
            },
        });
    },

    getTextContentRequest: (url: string, accessToken: string) => {
        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: url,
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);
                return {
                    textContent: apiResponse.getFieldAsObject('textContents'),
                };
            },
            update: {
                textContent: UpdateToNext,
            },
        });
    },

    getUserActivationRequest: (url: string, accessToken: string) => {
        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: url,
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);
                return {
                    activationUser: apiResponse.getFieldAsObject('user'),
                };
            },
            update: {
                activationUser: UpdateToNext,
            },
        });
    },

    getNewClientInviteRequest: (url: string, accessToken: string) => {
        return Object.assign({}, BaseRequestWithAuth(accessToken), {
            url: url,
            transform: (data) => {
                const apiResponse = new ApiQueryResponse(data);
                return {
                    newClientInviteUsers: apiResponse.getFieldAsArray('users'),
                    newClientInviteAssociations: apiResponse.getFieldAsArray('associations'),
                    newClientInvitePortalUsers: apiResponse.getFieldAsArray('portalUsers'),
                    newClientInviteTempPassword: apiResponse.getFieldAsObject('tempPassword'),
                };
            },
            update: {
                newClientInviteUsers: UpdateToNext,
                newClientInviteAssociations: UpdateToNext,
                newClientInvitePortalUsers: UpdateToNext,
                newClientInviteTempPassword: UpdateToNext,
            },
        });
    },
};

export const MapQueryStateToPropsByUrl = (url: string, state: any, props: any, mapping: any = {}) => {
    // Return a mapStateToProps definition including default values extended with optional mapping

    const baseMapping = {
        branding: state.branding,
        intl: state.intl,
        lookups: _.get(state, 'entities.lookups', {})
    };

    return Object.assign({}, baseMapping, mapping);
};

export const MapQueryStateToPropsRoot = (state: any, props: any, mapping: any = {}) => {
    // Used by components rendered outside of <AppLayout> (unauthorized views like Home and Login)
    return MapQueryStateToPropsByUrl('', state, props, mapping);
};



// WEBPACK FOOTER //
// ./src/queries/index.ts